module.exports = __webpack_public_path__ + "img/ico-notice.b27e657c.svg";